import service from "@/plugins/service"

import { createFormData } from '@/plugins/formData'

const base = "/warning"

export const getHandlersList = deviceCode => service({
  url: `${base}/workOrder/handler/list`,
  method: "GET",
  params: {
    deviceCode
  }
})

export const getReasonsList = warningType => service({
  url: `${base}/reason`,
  method: "GET",
  params: {
    warningType
  }
})

export const createOrder = o => {
  const data = createFormData(o)

  return service({
    url: `${base}/workOrder/create`,
    method: "POST",
    data
  })
}

export const queryOrders = (current, pageSize, data) => service({
  url: `${base}/workOrder/page`,
  method: "POST",
  params: {
    current,
    pageSize
  },
  data
})

export const updateOrder = o => {
  const data = createFormData(o)

  return service({
    url: `${base}/workOrder/update`,
    method: "POST",
    data
  })
}

export const getOrderByCode = code => service({
  url: `${base}/workOrder/get`,
  params: {
    code
  }
})

export const handleOrder = (code, estimatedTime) => {
  const data = new FormData()
  data.append("code", code)
  data.append("estimatedTime", estimatedTime)

  return service({
    url: `${base}/workOrder/handle`,
    method: "POST",
    data
  })
}

export const getHandleMethodList = warningType => service({
  url: `${base}/handleMethod`,
  method: "GET",
  params: {
    warningType
  }
})

export const finishOrder = (o, files) => {
  const data = createFormData(o)
  for (let i = 0; i < files.length; i++) {
    data.append("files", files[i])
  }

  return service({
    url: `${base}/workOrder/handle`,
    method: "POST",
    data
  })
}

export const getOrderCommentsList = workOrderCode => service({
  url: `${base}/workOrder/comment/list`,
  method: "GET",
  params: {
    workOrderCode
  }
})

export const createComment = o => {
  const data = createFormData(o)

  return service({
    url: `${base}/workOrder/comment/create`,
    method: "POST",
    data
  })
}

export const deleteComment = id => service({
  url: `${base}/workOrder/comment/remove`,
  method: "DELETE",
  params: {
    id
  }
})

export const deleteOrder = code => service({
  url: `${base}/workOrder/remove`,
  method: "DELETE",
  params: {
    code
  }
})

export const deleteOrderFile = (workOrderCode, attachmentCode) => service({
  url: `${base}/workOrder/removeAttachment`,
  method: "POST",
  params: {
    workOrderCode,
    attachmentCode
  }
})

export const getReasonsItemList = warningType => service({
  url: `${base}/reason`,
  method: "GET",
  params: {
    warningType
  }
})

export const insertReason = data => service({
  url: `${base}/reason/create`,
  method: "POST",
  data
})

export const updateReason = data => service({
  url: `${base}/reason/update`,
  method: "PUT",
  data
})

export const deleteReason = code => service({
  url: `${base}/reason/delete`,
  method: "DELETE",
  params: {
    code
  }
})

export const gethandleMethodsItemList = warningType => service({
  url: `${base}/handleMethod`,
  method: "GET",
  params: {
    warningType
  }
})

export const insertHandleMethod = data => service({
  url: `${base}/handleMethod/create`,
  method: "POST",
  data
})

export const updateHandleMethod = data => service({
  url: `${base}/handleMethod/update`,
  method: "PUT",
  data
})

export const deleteHandleMethod = code => service({
  url: `${base}/handleMethod/delete`,
  method: "DELETE",
  params: {
    code
  }
})